import axios from 'axios';
import { formatPhoneNumberForRequest } from '../../global/helpers';
import { TelegramAuthData } from './types';

export class LoginService {
  static API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/`;

  static auth = async (phoneNumber: string, validationCode: string) => {
    const headers = process.env.REACT_APP_INTEGRATION_NETWORK
      ? {
          'X-Integration-Code': process.env.REACT_APP_INTEGRATION_NETWORK,
        }
      : {};
    const response = await axios({
      method: 'post',
      url: `${LoginService.API_BASE_URL}accounting/auth`,
      data: JSON.stringify({
        phone: formatPhoneNumberForRequest(phoneNumber),
        validation_code: validationCode,
      }),
      headers,
    });
    return response.data;
  };

  static refreshTokens = async (refreshToken: string) => {
    const response = await fetch(
      `${LoginService.API_BASE_URL}users/auth/refresh`,
      {
        method: 'POST',
        body: JSON.stringify({
          refresh_token: refreshToken,
        }),
      }
    ).then((res) => res.json());

    return response;
  };

  static validatePhoneNumber = async (
    phoneNumber: string,
    method: 'sms' | 'whatsApp' | 'telegram'
  ) => {
    const endpointMap = {
      sms: 'sms',
      whatsApp: 'whatsapp',
      telegram: 'telegram',
    };
    const headers = process.env.REACT_APP_INTEGRATION_NETWORK
      ? {
          'X-Integration-Code': process.env.REACT_APP_INTEGRATION_NETWORK,
        }
      : {};
    const response = await axios({
      method: 'post',
      url: `${LoginService.API_BASE_URL}users/${endpointMap[method]}`,
      data: JSON.stringify({
        phone: formatPhoneNumberForRequest(phoneNumber),
        sms_type: 'auth',
      }),
      headers,
    });
    return response.data;
  };

  static getUserInfo = async (token: string) => {
    const response = await axios({
      method: 'get',
      url: `${LoginService.API_BASE_URL}users`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  static getNetworks = async (token: string, code: string) => {
    const response = await axios({
      method: 'get',
      url: code
        ? `${LoginService.API_BASE_URL}networks/${code}`
        : `${LoginService.API_BASE_URL}networks`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  static getSources = async (token: string, code?: string) => {
    const response = await axios({
      method: 'get',
      url: code
        ? `${LoginService.API_BASE_URL}sources/${code}`
        : `${LoginService.API_BASE_URL}sources`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  static telegramAuth = async (idToken: string) => {
    const headers = process.env.REACT_APP_INTEGRATION_NETWORK
      ? {
          'X-Integration-Code': process.env.REACT_APP_INTEGRATION_NETWORK,
        }
      : {};
    const response = await axios({
      method: 'post',
      url: `${LoginService.API_BASE_URL}users/auth/telegram`,
      data: JSON.stringify({ id_token: idToken }),
      headers,
    });
    return response.data;
  };

  static getWhatsappAuthNumber = async () => {
    const API_WARNING_MESSAGE_ULR =
      process.env.REACT_APP_API_BASE_URL?.includes('prod')
        ? 'https://getwarningmessage-production.up.railway.app/'
        : 'https://getwarningmessage-copy-production.up.railway.app/';
    const response = await axios({
      method: 'get',
      url: `${API_WARNING_MESSAGE_ULR}auth_phone`,
    });

    return response.data;
  };

  static getWarningMessage = async (beeline?: string) => {
    const site = beeline ? 'beeline' : 'daribar';
    try {
      if (process.env.REACT_APP_API_BASE_URL?.includes('prod')) {
        const response = await axios({
          method: 'get',
          url: `https://getwarningmessage-production.up.railway.app/?site=${site}`,
        });

        return response.data;
      }
      const response = await axios({
        method: 'get',
        url: `${LoginService.API_BASE_URL}warnings/${site}`,
      });
      return response.data.result.warning;
    } catch (error) {
      console.error(error);
    }
  };
}
